import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage";
import CristianPopa from "./components/CristianPopa";


function App() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
/*
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/test/`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((json) => setData(json.message))
      .catch((err) => {
        console.error(err);
        setError(err.message);
      });
  }, []);

  if (error) return <p style={{ color: "red" }}>Error: {error}</p>;
  if (data === null) return <p>Loading...</p>;
  console.log(data);
  */
  return (
    <Router>
      <Routes>
        {/* Homepage route */}
        <Route path="/" element={<Homepage />} />
        <Route path="/cristian" element={<CristianPopa />} />
        
        {/* /test route with backend message */}
        
      </Routes>
    </Router>
  );
}

export default App;